class SetPermissionsCtrl {

    constructor($scope, $uibModalInstance, $q, $apiService, CONTENT_TYPE) {
        this.$scope = $scope;
        this.$scope.loading = true;
        this.$uibModalInstance = $uibModalInstance;
        
        this.$scope.types = ['account', 'advertiser', 'campaign'];
        this.$scope.data = {};

        $q.all([
            $apiService.list(CONTENT_TYPE.ACCOUNT, ''),
            $apiService.list(CONTENT_TYPE.ADVERTISER, ''),
            $apiService.list(CONTENT_TYPE.CAMPAIGN, '')
        ]).then(response => {
            this.$scope.data.account = response[0].data;
            this.$scope.data.advertiser = response[1].data;
            this.$scope.data.campaign = response[2].data;
            
            this.$scope.rows = ($scope.$resolve != null && $scope.$resolve.hasOwnProperty('user') && $scope.$resolve.user.permissions.length > 0)
                ? this.permissionToObjects($scope.$resolve.user.permissions)
                : [];
            this.$scope.loading = false;
        });

        this.$scope.ok = this.ok.bind(this);
        this.$scope.cancel = this.cancel.bind(this);
        this.$scope.addRow = this.addRow.bind(this);
        this.$scope.removeRow = this.removeRow.bind(this);
    }

    addRow() {
        this.$scope.rows.push({
            type: 'account',
            entity: null,
            read: true,
            write: true
        });
    }

    removeRow(index) {
        this.$scope.rows.splice(index, 1);
    }

    ok() {
        var items = this.objectToPermissions(this.$scope.rows);
        this.$uibModalInstance.close(items);
    }
    
    permissionToObjects(items) {
        let rows = [];
        items.forEach(item => {
            let [type, rw, entity] = item.split(':');
            let existing = rows.filter(r => r.type === type && r.entity === +entity)[0];
            if (existing) {
                let index = rows.indexOf(existing);
                if (rw === 'read') {
                    rows[index].read = true;
                } else if (rw === 'write') {
                    rows[index].write = true;
                }
            } else {
                rows.push({
                    type: type,
                    entity: +entity,
                    read: rw === 'read',
                    write: rw === 'write'
                });
            }
        });
        console.log(rows);
        return rows;
    }
    
    objectToPermissions(items) {
        let strings = [];
        items.forEach(item => {
            if (item.type != null && item.entity != null) {
                if (item.read === true) {
                    strings.push([item.type, 'read', item.entity].join(':'));
                }
                if (item.write === true) {
                    strings.push([item.type, 'write', item.entity].join(':'));
                }
            }
        });
        return strings;
    }

    cancel() {
        this.$uibModalInstance.dismiss('cancel');
    }
}

angular.module("cpm")
    .controller('SetPermissionsCtrl', ['$scope', '$uibModalInstance', '$q', 'ApiService', 'CONTENT_TYPE', SetPermissionsCtrl]);
